<template>
  <div class="kt-portlet kt-portlet--bordered">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <span class="kt-portlet__head-icon">
          <i class="flaticon2-information" />
        </span>
        <h3 class="kt-portlet__head-title">
          Account Info
        </h3>
      </div>
    </div>
    <div class="kt-portlet__body">
      <storage-limit-progress-bar />
    </div>
  </div>
</template>

<script>
import StorageLimitProgressBar from "VuePartials/StorageLimitProgressBar";

export default {
  components: {
    StorageLimitProgressBar,
  },
  data: () => ({
    user: window.user,
    auth_user: window.auth_user,
  }),
};
</script>

<style scoped>
.account-info {
    padding: 20px;
}
</style>
